
<div class="btn-group tab_btn_group" style="display: block !important; z-index: 9999; padding-top: 10px;">
  <button type="button" [ngClass]="accColor1" [disabled]="accColor1 == 'active'" class="btn"
    (click)="selectFilterAccelartion('Hourly',chartContainerId)">
    Hourly
  </button>
  <button type="button" [ngClass]="accColor2" [disabled]="accColor2 == 'active'" class="btn"
    (click)="selectFilterAccelartion('Daily',chartContainerId)">
    Daily
  </button>

  <button type="button" [ngClass]="accColor3" [disabled]="accColor3 == 'active'" class="btn"
    (click)="selectFilterAccelartion('Weekly',chartContainerId)">
    Weekly
  </button>
  <span *ngIf="chartType != 'column'" id="closeBtn" class="close-btn" (click)="closeFunction()"><b>X</b></span>
   <ng-template #elseCondition>
    <div class="legendbox" style="margin-top: -10px; margin-right: 30px;">
      <div style="background-color: #ff2a1b;"></div><strong>ON</strong>
      <div style="background-color: #72FF13;;"></div><strong>OFF</strong>
    </div>
    <span id="closeBtn" class="close-btn-col" style="z-index: 9999;" (click)="closeFunction()"><b>X</b></span>
  </ng-template>
</div>

  <div class="table-responsive" style="z-index: 19; position: relative;" *ngIf="chartType != 'column'; else elseCondition">
    <table class="moving_avg">
      <thead>
        <tr>
          <th></th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody *ngIf="!visibilityVAT; else elseBlock">
        <tr>
          <th style="text-align: left">1 Day Avg.</th>
          <td>{{day_1}}</td>
        </tr>
        <tr>
          <th style="text-align: left">7 Days Avg.</th>
          <td>{{days_7}}</td>
        </tr>
        <tr>
          <th style="text-align: left">30 Days Avg.</th>
          <td>{{days_30}}</td>
        </tr>
      </tbody>
      <tbody>
        <ng-template #elseBlock>
          <tr>
            <td colspan="4" class="errorDisplay">
              No data available for last 24 Hour!
            </td>
          </tr>
        </ng-template>
      </tbody>
    </table>
    
  </div>
  
  <strong class="unit" *ngIf="chartUnit != undefined">({{chartUnit}})</strong>
  
 
  <!-- <span id="closeBtn" class="close-btn"><b>X</b></span> -->
 <div [id]="chartContainerId" style="height: 680px; width: 100%;"></div>